export namespace IBalance {
  export const ACTION = 'balance';
  export const ACTION_PAY = 'bank_pay';
  export const Action = {
    ReCalcSaldo: 'ReCalcSaldo',
  };

  export enum Command {
    Add = 'Add',
    Reversal = 'Reversal',
    ReversalMsg = 'reversalMsg',
    RegisterDo = 'registerDo',
  }

  export interface IResponse {
    saldo: number;
    spec: ISpecItem[];
  }

  export interface ISpecItem {
    dateRpt: string;
    status: string;
    tSum: number;
    typeId: IProcessType;
    typeName: string;
  }

  export enum IProcessType {
    FromBank = 1,
    ArrivalCard = 2,
    TerminalPay = 3,
    SetParking = 4,
    CardRejected = 5,
    Correction = 7,
  }

  export interface IFilters {
    corpId: number;
    dateBeg?: string;
    dateEnd?: string;
    statusStr?: number[];
  }

  export enum StorageKeys {
    BalanceEmail = 'payBuyCardEmail',
    BalancePhone = 'payBuyCardPhone',
  }

  export enum Events {
    OpenPaymentResultPage = 'paymentResultPage:open'
  }
}
